/* @flow */

import classNames from 'classnames';
import { compose } from 'ramda';
import * as React from 'react';
import { createUseStyles } from 'react-jss';

import styles from './BlackSection.style';

const useStyles = createUseStyles(styles);

const BlackSection = (): React.Node => {
  /*
   |----------------------------------------------------------------------------
   | Classes
   |----------------------------------------------------------------------------
   */

  const classes: Object = useStyles();

  /*
   |----------------------------------------------------------------------------
   | Elements
   |----------------------------------------------------------------------------
   */

  return (
    <ul className={classNames(classes.list, classes.blacks)}>
      <li className={classes.item}>
        <div className={classes.swatch} />
      </li>
      <li className={classes.item}>
        <div className={classes.swatch} />
      </li>
      <li className={classes.item}>
        <div className={classes.swatch} />
      </li>
      <li className={classes.item}>
        <div className={classes.swatch} />
      </li>
      <li className={classes.item}>
        <div className={classes.swatch} />
      </li>
      <li className={classes.item}>
        <div className={classes.swatch} />
      </li>
      <li className={classes.item}>
        <div className={classes.swatch} />
      </li>
      <li className={classes.item}>
        <div className={classes.swatch} />
      </li>
      <li className={classes.item}>
        <div className={classes.swatch} />
      </li>
    </ul>
  );
};

export default compose(React.memo)(BlackSection);
